import React, { useEffect, useState } from "react"
import axios from "axios"
const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

interface Modelo { id: string; nome: string; tipo: string; descricao: string | null; ativo: boolean; periodicidade?: string; tipos_ativo_ids?: string[]; cliente_id?: string | null; modelo_base_id?: string | null }
interface Item { id: string; pergunta: string; tipo_resposta: string; exige_foto: boolean; obrigatorio: boolean; ordem: number; pode_gerar_os?: boolean; lado?: string | null; posicao?: string | null; permite_nao_possui?: boolean }
interface TipoVeiculo { id: string; nome: string }
interface Ativo { id: string; nome: string; placa: string | null }
interface Grupo { id: string; nome: string; tipo: string }

const DIAS_SEMANA = [
  { valor: 0, label: "Dom" }, { valor: 1, label: "Seg" }, { valor: 2, label: "Ter" },
  { valor: 3, label: "Qua" }, { valor: 4, label: "Qui" }, { valor: 5, label: "Sex" },
  { valor: 6, label: "Sab" },
]
const PERIODICIDADES = [
  { valor: "quinzenal", label: "Quinzenal", legenda: "01 a 15 e 16 a 30" },
  { valor: "mensal", label: "Mensal", legenda: "todo dia 01" },
]

const TIPOS = [
  { valor: "chegada", label: "Chegada / Retorno" },
  { valor: "vistoria", label: "Vistoria Preventiva" },
  { valor: "entrega", label: "Entrega (aluguel)" },
  { valor: "recebimento", label: "Recebimento (aluguel)" },
]

const LADOS = [
  { valor: "", label: "Central (sem lado)" },
  { valor: "E", label: "Lado do Motorista (esquerdo)" },
  { valor: "D", label: "Lado do Passageiro (direito)" },
]
const POSICOES = [
  { valor: "frente45", label: "Frente 45° (canto dianteiro)" },
  { valor: "lateral", label: "Lateral completa" },
  { valor: "traseira45", label: "Traseira 45° (canto traseiro)" },
  { valor: "porta_diant", label: "Porta dianteira (por dentro)" },
  { valor: "porta_tras", label: "Porta traseira (por dentro)" },
  { valor: "detalhe", label: "Detalhe do lado (para-lama, roda...)" },
]

const TIPOS_RESPOSTA = [
  { valor: "sim_nao", label: "Conforme / Não Conforme" },
  { valor: "nota", label: "Nota (1 a 5)" },
  { valor: "texto", label: "Texto livre" },
  { valor: "opcoes", label: "Múltipla escolha" },
  { valor: "foto", label: "📷 Só foto (vistoria fotográfica)" },
]

export default function ChecklistModelos() {
  const [tipoSelecionado, setTipoSelecionado] = useState(TIPOS[0].valor)
  const [modelos, setModelos] = useState<Modelo[]>([])
  const [modeloSelecionado, setModeloSelecionado] = useState<Modelo | null>(null)
  const [itens, setItens] = useState<Item[]>([])
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro] = useState("")

  const [modalModelo, setModalModelo] = useState(false)
  const [editandoModelo, setEditandoModelo] = useState<Modelo | null>(null)
  const [nomeModelo, setNomeModelo] = useState("")
  const [descricaoModelo, setDescricaoModelo] = useState("")
  const [periodicidadeModelo, setPeriodicidadeModelo] = useState("sem_periodicidade")
  const [diasSemanaSelecionados, setDiasSemanaSelecionados] = useState<number[]>([])
  const [frotaSelecionada, setFrotaSelecionada] = useState<string[]>([])
  const [tiposVeiculo, setTiposVeiculo] = useState<TipoVeiculo[]>([])
  const [ativosDisponiveis, setAtivosDisponiveis] = useState<Ativo[]>([])
  const [gruposDisponiveis, setGruposDisponiveis] = useState<Grupo[]>([])
  const [ativosSelecionados, setAtivosSelecionados] = useState<string[]>([])
  const [gruposSelecionados, setGruposSelecionados] = useState<string[]>([])
  const [buscaAtivo, setBuscaAtivo] = useState("")
  const [buscaGrupo, setBuscaGrupo] = useState("")
  const [dropdownGrupoAberto, setDropdownGrupoAberto] = useState(false)

  const [novaPergunta, setNovaPergunta] = useState("")
  const [novoTipoResposta, setNovoTipoResposta] = useState("sim_nao")
  const [novoExigeFoto, setNovoExigeFoto] = useState(false)
  const [novoPodeGerarOs, setNovoPodeGerarOs] = useState(false)
  const [novaSubPergunta, setNovaSubPergunta] = useState("")
  const [novasSubOpcoes, setNovasSubOpcoes] = useState("")
  const [novoLado, setNovoLado] = useState("")
  const [novaPosicao, setNovaPosicao] = useState("detalhe")
  const [novoPermiteNaoPossui, setNovoPermiteNaoPossui] = useState(false)
  const [novoAmbosLados, setNovoAmbosLados] = useState(false)
  const [modalImportar, setModalImportar] = useState(false)
  const [itensGlobais, setItensGlobais] = useState<any[]>([])
  const [itensParaImportar, setItensParaImportar] = useState<string[]>([])
  const [importando, setImportando] = useState(false)
  const [editandoItem, setEditandoItem] = useState<Item | null>(null)

  const token = () => localStorage.getItem("moobi_token")
  const headers = () => ({ Authorization: `Bearer ${token()}` })

  const carregarModelos = async (tipo: string) => {
    const r = await axios.get(`${API}/checklist-modelos`, { headers: headers(), params: { tipo } })
    setModelos(r.data)
  }

  const carregarItens = async (modeloId: string) => {
    const r = await axios.get(`${API}/checklist-modelos/${modeloId}/itens`, { headers: headers() })
    setItens(r.data)
  }

  useEffect(() => {
    (async () => {
      setCarregando(true)
      await carregarModelos(tipoSelecionado)
      try {
        const r = await axios.get(`${API}/ativos/tipos`, { headers: headers() })
        setTiposVeiculo(r.data)
      } catch {}
      try {
        const r = await axios.get(`${API}/ativos`, { headers: headers() })
        setAtivosDisponiveis(r.data)
      } catch {}
      try {
        const r = await axios.get(`${API}/grupos`, { headers: headers() })
        setGruposDisponiveis(r.data)
      } catch {}
      setCarregando(false)
    })()
  }, [])

  useEffect(() => {
    setModeloSelecionado(null)
    setItens([])
    carregarModelos(tipoSelecionado)
  }, [tipoSelecionado])

  useEffect(() => {
    if (modeloSelecionado) carregarItens(modeloSelecionado.id)
    else setItens([])
  }, [modeloSelecionado])

  const abrirNovoModelo = () => {
    setEditandoModelo(null)
    setNomeModelo("")
    setDescricaoModelo("")
    setPeriodicidadeModelo("sem_periodicidade")
    setFrotaSelecionada([])
    setAtivosSelecionados([])
    setGruposSelecionados([])
    setDiasSemanaSelecionados([])
    setBuscaAtivo("")
    setModalModelo(true)
  }

  const abrirEditarModelo = (m: Modelo) => {
    setEditandoModelo(m)
    setNomeModelo(m.nome)
    setDescricaoModelo(m.descricao || "")
    setPeriodicidadeModelo(m.periodicidade || "sem_periodicidade")
    setFrotaSelecionada(m.tipos_ativo_ids || [])
    setAtivosSelecionados((m as any).ativos_ids || [])
    setGruposSelecionados((m as any).grupo_ids || [])
    setDiasSemanaSelecionados((m as any).dias_semana || [])
    setBuscaAtivo("")
    setModalModelo(true)
  }

  const alternarDiaSemana = (dia: number) => {
    setDiasSemanaSelecionados(atuais => atuais.includes(dia) ? atuais.filter(x => x !== dia) : [...atuais, dia])
  }

  const alternarFrota = (id: string) => {
    setFrotaSelecionada(atuais => atuais.includes(id) ? atuais.filter(x => x !== id) : [...atuais, id])
  }
  const alternarAtivo = (id: string) => {
    setAtivosSelecionados(atuais => atuais.includes(id) ? atuais.filter(x => x !== id) : [...atuais, id])
  }
  const alternarGrupo = (id: string) => {
    setGruposSelecionados(atuais => atuais.includes(id) ? atuais.filter(x => x !== id) : [...atuais, id])
  }

  const salvarModelo = async () => {
    if (!nomeModelo.trim()) { setErro("Digite o nome do modelo"); return }
    setErro("")
    try {
      let modeloSalvo: Modelo
      if (editandoModelo) {
        const r = await axios.put(`${API}/checklist-modelos/${editandoModelo.id}`, {
          nome: nomeModelo, descricao: descricaoModelo, periodicidade: periodicidadeModelo,
          tipos_ativo_ids: frotaSelecionada, ativos_ids: ativosSelecionados, grupo_ids: gruposSelecionados,
          dias_semana: diasSemanaSelecionados,
        }, { headers: headers() })
        modeloSalvo = r.data
      } else {
        const r = await axios.post(`${API}/checklist-modelos`, {
          nome: nomeModelo, tipo: tipoSelecionado, descricao: descricaoModelo,
          periodicidade: periodicidadeModelo, tipos_ativo_ids: frotaSelecionada,
          ativos_ids: ativosSelecionados, grupo_ids: gruposSelecionados,
          dias_semana: diasSemanaSelecionados,
        }, { headers: headers() })
        modeloSalvo = r.data
      }
      setModalModelo(false)
      await carregarModelos(tipoSelecionado)
      // Ja seleciona o modelo recem-criado/editado, pra abrir direto o
      // painel de perguntas — sem isso o usuario tinha que clicar de novo
      // na lista pra achar onde configurar o que o motorista vai verificar.
      setModeloSelecionado(modeloSalvo)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao salvar") }
  }

  const personalizarModelo = async (m: Modelo) => {
    const msg = m.cliente_id
      ? `Criar uma cópia do modelo "${m.nome}"?`
      : `Criar uma cópia do modelo padrão "${m.nome}" para a sua empresa? Você poderá remover, adicionar e alterar as fotos e perguntas sem afetar o padrão.`
    if (!window.confirm(msg)) return
    setErro("")
    try {
      const r = await axios.post(`${API}/checklist-modelos/${m.id}/duplicar`, {}, { headers: headers() })
      await carregarModelos(tipoSelecionado)
      setModeloSelecionado(r.data)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao duplicar o modelo") }
  }

  const excluirModelo = async (m: Modelo) => {
    if (!window.confirm(`Remover o modelo "${m.nome}"? As perguntas dele tambem somem.`)) return
    try { await axios.delete(`${API}/checklist-modelos/${m.id}`, { headers: headers() }) }
    catch (e: any) { setErro(e.response?.data?.erro || "Erro ao remover o modelo"); return }
    if (modeloSelecionado?.id === m.id) setModeloSelecionado(null)
    await carregarModelos(tipoSelecionado)
  }

  const abrirImportar = async () => {
    try {
      const r = await axios.get(`${API}/checklist-itens`, { headers: headers() })
      setItensGlobais(r.data)
    } catch { setItensGlobais([]) }
    setItensParaImportar([])
    setModalImportar(true)
  }

  const alternarItemImportar = (id: string) => {
    setItensParaImportar(atuais => atuais.includes(id) ? atuais.filter(x => x !== id) : [...atuais, id])
  }

  const importarSelecionadas = async () => {
    if (!modeloSelecionado || itensParaImportar.length === 0) return
    setImportando(true)
    try {
      for (const id of itensParaImportar) {
        const item = itensGlobais.find(x => x.id === id)
        if (!item) continue
        await axios.post(`${API}/checklist-modelos/${modeloSelecionado.id}/itens`, {
          pergunta: item.pergunta, tipo_resposta: item.tipo_resposta, exige_foto: item.exige_foto,
          pode_gerar_os: item.pode_gerar_os,
          lado: item.lado || null, posicao: item.posicao || null, permite_nao_possui: item.permite_nao_possui || false,
          sub_pergunta: item.sub_pergunta || null, sub_opcoes: item.sub_opcoes || [],
        }, { headers: headers() })
      }
      setModalImportar(false)
      await carregarItens(modeloSelecionado.id)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao importar") }
    setImportando(false)
  }

  const criarItem = async () => {
    if (!novaPergunta.trim() || !modeloSelecionado) return
    setErro("")
    try {
      const ehFoto = novoTipoResposta === "foto"
      const base = {
        tipo_resposta: novoTipoResposta, exige_foto: ehFoto ? true : novoExigeFoto,
        pode_gerar_os: novoPodeGerarOs,
        sub_pergunta: novaSubPergunta.trim() || null,
        sub_opcoes: novasSubOpcoes.split(",").map(s => s.trim()).filter(Boolean),
        permite_nao_possui: ehFoto ? novoPermiteNaoPossui : false,
      }
      const url = `${API}/checklist-modelos/${modeloSelecionado.id}/itens`
      const nome = novaPergunta.trim()
      if (ehFoto && novoLado && novoAmbosLados) {
        // cria o par: um item pro lado do motorista e outro pro lado do passageiro
        await axios.post(url, { ...base, pergunta: `${nome} (Motorista)`, lado: "E", posicao: novaPosicao }, { headers: headers() })
        await axios.post(url, { ...base, pergunta: `${nome} (Passageiro)`, lado: "D", posicao: novaPosicao }, { headers: headers() })
      } else {
        await axios.post(url, {
          ...base, pergunta: nome,
          lado: ehFoto && novoLado ? novoLado : null,
          posicao: ehFoto && novoLado ? novaPosicao : null,
        }, { headers: headers() })
      }
      setNovaPergunta(""); setNovoTipoResposta("sim_nao"); setNovoExigeFoto(false); setNovoPodeGerarOs(false)
      setNovaSubPergunta(""); setNovasSubOpcoes("")
      setNovoLado(""); setNovaPosicao("detalhe"); setNovoPermiteNaoPossui(false); setNovoAmbosLados(false)
      await carregarItens(modeloSelecionado.id)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao criar pergunta") }
  }

  const salvarEdicaoItem = async () => {
    if (!editandoItem || !modeloSelecionado) return
    try {
      await axios.put(`${API}/checklist-itens/${editandoItem.id}`, {
        pergunta: editandoItem.pergunta, tipo_resposta: editandoItem.tipo_resposta,
        exige_foto: editandoItem.exige_foto, obrigatorio: editandoItem.obrigatorio,
        pode_gerar_os: editandoItem.pode_gerar_os,
        sub_pergunta: (editandoItem as any).sub_pergunta || null,
        sub_opcoes: (editandoItem as any).sub_opcoes || [],
        lado: editandoItem.tipo_resposta === "foto" ? (editandoItem.lado || null) : null,
        posicao: editandoItem.tipo_resposta === "foto" && editandoItem.lado ? (editandoItem.posicao || "detalhe") : null,
        permite_nao_possui: editandoItem.tipo_resposta === "foto" ? (editandoItem.permite_nao_possui || false) : false,
      }, { headers: headers() })
      setEditandoItem(null)
      await carregarItens(modeloSelecionado.id)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao editar pergunta") }
  }

  const excluirItem = async (it: Item) => {
    if (!window.confirm(`Remover a pergunta "${it.pergunta}"?`)) return
    try { await axios.delete(`${API}/checklist-itens/${it.id}`, { headers: headers() }) }
    catch (e: any) { setErro(e.response?.data?.erro || "Erro ao remover a pergunta"); return }
    if (modeloSelecionado) await carregarItens(modeloSelecionado.id)
  }

  const corFundo = "#0d1b2e", corCard = "#1e2f4a", corBorda = "#2d4166", corTexto = "#f1f5f9", corMuted = "#94a3b8", corAccent = "#0ea5e9"

  const estiloInput: React.CSSProperties = {
    flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${corBorda}`,
    background: corCard, color: corTexto, fontSize: 13, boxSizing: "border-box",
  }
  const estiloBotao: React.CSSProperties = {
    padding: "9px 16px", borderRadius: 8, border: "none", cursor: "pointer",
    background: corAccent, color: "#fff", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap",
  }
  const estiloLinha: React.CSSProperties = {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
    borderRadius: 8, border: `1px solid ${corBorda}`, marginBottom: 6,
  }
  const estiloIconeAcao: React.CSSProperties = { cursor: "pointer", color: corMuted, fontSize: 15, padding: 4 }

  if (carregando) return <div style={{ padding: 32, color: corMuted }}>Carregando...</div>

  return (
    <div style={{ padding: 24, height: "100%", overflow: "auto", background: corFundo, color: corTexto }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Modelos de Checklist</h2>
      <p style={{ fontSize: 12, color: corMuted, marginBottom: 20 }}>
        Configure as perguntas de cada tipo de checklist — preenchidas pelo motorista no app.
      </p>
      {!!erro && <div style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{erro}</div>}

      <div style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap" }}>
        {TIPOS.map(t => (
          <button key={t.valor} onClick={() => setTipoSelecionado(t.valor)}
            style={{ padding: "8px 16px", borderRadius: 20, cursor: "pointer", fontSize: 12.5,
              border: `1px solid ${tipoSelecionado === t.valor ? corAccent : corBorda}`,
              background: tipoSelecionado === t.valor ? "rgba(14,165,233,0.15)" : "transparent",
              color: tipoSelecionado === t.valor ? "#38bdf8" : corMuted,
              fontWeight: tipoSelecionado === t.valor ? 600 : 400 }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: corMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>Modelos</div>
            <button style={{ ...estiloBotao, padding: "6px 12px" }} onClick={abrirNovoModelo}>+ Novo</button>
          </div>
          {modelos.map(m => (
            <div key={m.id} style={{ ...estiloLinha, background: modeloSelecionado?.id === m.id ? "rgba(14,165,233,0.1)" : "transparent", cursor: "pointer" }}
              onClick={() => setModeloSelecionado(m)}>
              <span style={{ flex: 1, fontSize: 13 }}>{m.nome}</span>
              {!m.cliente_id && <span style={{ fontSize: 10, color: corMuted, border: `1px solid ${corBorda}`, borderRadius: 10, padding: "1px 7px" }} title="Modelo padrão do sistema">padrão</span>}
              <span style={estiloIconeAcao} title={m.cliente_id ? "Duplicar este modelo" : "Personalizar para minha empresa"} onClick={e => { e.stopPropagation(); personalizarModelo(m) }}>📑</span>
              <span style={estiloIconeAcao} onClick={e => { e.stopPropagation(); abrirEditarModelo(m) }}>✏️</span>
              <span style={estiloIconeAcao} onClick={e => { e.stopPropagation(); excluirModelo(m) }}>🗑️</span>
            </div>
          ))}
          {modelos.length === 0 && <div style={{ color: corMuted, fontSize: 12 }}>Nenhum modelo pra esse tipo ainda.</div>}
        </div>

        <div style={{ flex: 2, minWidth: 340 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: corMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>
              Perguntas {modeloSelecionado ? `— ${modeloSelecionado.nome}` : ""}
            </div>
            {modeloSelecionado && (
              <button style={{ ...estiloBotao, padding: "6px 12px", background: "none", border: `1px solid ${corAccent}`, color: corAccent }}
                onClick={abrirImportar}>📋 Importar de outro modelo</button>
            )}
          </div>
          {!modeloSelecionado ? (
            <div style={{ color: corMuted, fontSize: 12 }}>Selecione um modelo à esquerda pra ver/adicionar as perguntas dele.</div>
          ) : (
            <>
              <div style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
                <input style={{ ...estiloInput, minWidth: 220 }} placeholder="Ex: Pneus em bom estado?"
                  value={novaPergunta} onChange={e => setNovaPergunta(e.target.value)} />
                <select style={{ ...estiloInput, flex: "0 0 160px" }} value={novoTipoResposta} onChange={e => setNovoTipoResposta(e.target.value)}>
                  {TIPOS_RESPOSTA.map(tr => <option key={tr.valor} value={tr.valor}>{tr.label}</option>)}
                </select>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: corMuted }}>
                  <input type="checkbox" checked={novoExigeFoto} onChange={e => setNovoExigeFoto(e.target.checked)} />
                  Exige foto
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: corMuted }}>
                  <input type="checkbox" checked={novoPodeGerarOs} onChange={e => setNovoPodeGerarOs(e.target.checked)} />
                  Pode gerar OS
                </label>
                <button style={estiloBotao} onClick={criarItem}>+ Adicionar</button>
              </div>
              {novoTipoResposta === "foto" && (
                <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", padding: 10, background: "#162035", borderRadius: 8, alignItems: "center" }}>
                  <div style={{ fontSize: 11, color: corMuted, width: "100%" }}>
                    Vistoria fotográfica — escolha de qual lado do veículo é a foto. A ordem no app e no relatório é automática:
                    todo o lado do motorista, todo o lado do passageiro e depois os itens centrais.
                  </div>
                  <select style={{ ...estiloInput, flex: "0 0 220px" }} value={novoLado} onChange={e => setNovoLado(e.target.value)}>
                    {LADOS.map(l => <option key={l.valor} value={l.valor}>{l.label}</option>)}
                  </select>
                  {!!novoLado && (
                    <select style={{ ...estiloInput, flex: "0 0 240px" }} value={novaPosicao} onChange={e => setNovaPosicao(e.target.value)}>
                      {POSICOES.map(p => <option key={p.valor} value={p.valor}>{p.label}</option>)}
                    </select>
                  )}
                  <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: corMuted }}>
                    <input type="checkbox" checked={novoPermiteNaoPossui} onChange={e => setNovoPermiteNaoPossui(e.target.checked)} />
                    Permite "Não possui"
                  </label>
                  {!!novoLado && (
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: corMuted }}>
                      <input type="checkbox" checked={novoAmbosLados} onChange={e => setNovoAmbosLados(e.target.checked)} />
                      Criar para os dois lados (Motorista e Passageiro)
                    </label>
                  )}
                </div>
              )}
              {novoPodeGerarOs && (
                <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", padding: 10, background: "#162035", borderRadius: 8 }}>
                  <div style={{ fontSize: 11, color: corMuted, width: "100%" }}>
                    Opcional — pergunta extra que so aparece quando o motorista responder "Nao conforme" (ex: qual lado)
                  </div>
                  <input style={{ ...estiloInput, minWidth: 180 }} placeholder="Ex: Qual lado?"
                    value={novaSubPergunta} onChange={e => setNovaSubPergunta(e.target.value)} />
                  <input style={{ ...estiloInput, minWidth: 220 }} placeholder="Opcoes separadas por virgula — Ex: LD, LE, Ambos"
                    value={novasSubOpcoes} onChange={e => setNovasSubOpcoes(e.target.value)} />
                </div>
              )}
              {itens.some(it => it.tipo_resposta === "foto") && (
                <div style={{ fontSize: 11, color: corMuted, marginBottom: 10 }}>
                  📷 A lista está na ordem em que o app pede as fotos: lado do motorista → lado do passageiro → itens centrais.
                  Os itens centrais seguem a ordem em que foram cadastrados.
                </div>
              )}
              {itens.map(it => (
                <div key={it.id} style={{ ...estiloLinha, flexWrap: "wrap" }}>
                  {editandoItem?.id === it.id ? (
                    <>
                      <input style={estiloInput} value={editandoItem.pergunta}
                        onChange={e => setEditandoItem({ ...editandoItem, pergunta: e.target.value })} autoFocus />
                      <select style={{ ...estiloInput, flex: "0 0 150px" }} value={editandoItem.tipo_resposta}
                        onChange={e => setEditandoItem({ ...editandoItem, tipo_resposta: e.target.value })}>
                        {TIPOS_RESPOSTA.map(tr => <option key={tr.valor} value={tr.valor}>{tr.label}</option>)}
                      </select>
                      <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: corMuted }}>
                        <input type="checkbox" checked={editandoItem.exige_foto}
                          onChange={e => setEditandoItem({ ...editandoItem, exige_foto: e.target.checked })} />
                        Foto
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: corMuted }}>
                        <input type="checkbox" checked={editandoItem.pode_gerar_os || false}
                          onChange={e => setEditandoItem({ ...editandoItem, pode_gerar_os: e.target.checked })} />
                        OS
                      </label>
                      {editandoItem.tipo_resposta === "foto" && (
                        <>
                          <select style={{ ...estiloInput, flex: "0 0 200px" }} value={editandoItem.lado || ""}
                            onChange={e => setEditandoItem({ ...editandoItem, lado: e.target.value || null })}>
                            {LADOS.map(l => <option key={l.valor} value={l.valor}>{l.label}</option>)}
                          </select>
                          {!!editandoItem.lado && (
                            <select style={{ ...estiloInput, flex: "0 0 220px" }} value={editandoItem.posicao || "detalhe"}
                              onChange={e => setEditandoItem({ ...editandoItem, posicao: e.target.value })}>
                              {POSICOES.map(p => <option key={p.valor} value={p.valor}>{p.label}</option>)}
                            </select>
                          )}
                          <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: corMuted }}>
                            <input type="checkbox" checked={editandoItem.permite_nao_possui || false}
                              onChange={e => setEditandoItem({ ...editandoItem, permite_nao_possui: e.target.checked })} />
                            Não possui
                          </label>
                        </>
                      )}
                      <span style={estiloIconeAcao} onClick={salvarEdicaoItem}>✅</span>
                      <span style={estiloIconeAcao} onClick={() => setEditandoItem(null)}>✖️</span>
                    </>
                  ) : (
                    <>
                      <span style={{ flex: 1, fontSize: 13 }}>{it.pergunta}</span>
                      <span style={{ fontSize: 11, color: corMuted }}>{TIPOS_RESPOSTA.find(tr => tr.valor === it.tipo_resposta)?.label}</span>
                      {it.exige_foto && <span style={{ fontSize: 14 }} title="Exige foto">📷</span>}
                      {it.pode_gerar_os && <span style={{ fontSize: 14 }} title="Pode gerar OS automatica">🔧</span>}
                      {it.lado === "E" && <span style={{ fontSize: 10, color: "#38bdf8", border: "1px solid #0ea5e9", borderRadius: 10, padding: "1px 7px" }}>Motorista</span>}
                      {it.lado === "D" && <span style={{ fontSize: 10, color: "#a78bfa", border: "1px solid #8b5cf6", borderRadius: 10, padding: "1px 7px" }}>Passageiro</span>}
                      {it.permite_nao_possui && <span style={{ fontSize: 10, color: "#fbbf24" }} title="O motorista pode marcar 'Não possui'">⊘ não possui</span>}
                      <span style={estiloIconeAcao} onClick={() => setEditandoItem(it)}>✏️</span>
                      <span style={estiloIconeAcao} onClick={() => excluirItem(it)}>🗑️</span>
                    </>
                  )}
                </div>
              ))}
              {itens.length === 0 && <div style={{ color: corMuted, fontSize: 12 }}>Nenhuma pergunta cadastrada pra esse modelo ainda.</div>}
            </>
          )}
        </div>
      </div>

      {modalModelo && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 999,
          display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setModalModelo(false)}>
          <div style={{ background: corFundo, border: `1px solid ${corBorda}`, borderRadius: 12, padding: 28, width: 420 }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 18 }}>
              {editandoModelo ? "✏️ Editar modelo" : "📋 Novo modelo"}
            </h3>
            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Nome</label>
            <input style={{ ...estiloInput, width: "100%", marginBottom: 16 }} placeholder="Ex: Checklist de saida - Motos"
              value={nomeModelo} onChange={e => setNomeModelo(e.target.value)} autoFocus />
            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Descricao — opcional</label>
            <input style={{ ...estiloInput, width: "100%", marginBottom: 16 }} placeholder="Opcional"
              value={descricaoModelo} onChange={e => setDescricaoModelo(e.target.value)} />

            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Periodicidade — opcional</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
              {PERIODICIDADES.map(p => {
                const marcado = periodicidadeModelo === p.valor
                return (
                  <button type="button" key={p.valor}
                    onClick={() => setPeriodicidadeModelo(marcado ? "sem_periodicidade" : p.valor)}
                    style={{ padding: "8px 14px", borderRadius: 8, border: "none", cursor: "pointer",
                      fontFamily: "Inter", textAlign: "left",
                      background: marcado ? "#0ea5e9" : "#1a2744",
                      outline: marcado ? "2px solid #0ea5e9" : "1px solid #2d4166" }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: marcado ? "#fff" : "#94a3b8" }}>{p.label}</div>
                    <div style={{ fontSize: 10, color: marcado ? "rgba(255,255,255,0.8)" : "#64748b" }}>{p.legenda}</div>
                  </button>
                )
              })}
            </div>

            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>📅 Dias da semana obrigatórios — opcional</label>
            <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
              {DIAS_SEMANA.map(d => {
                const marcado = diasSemanaSelecionados.includes(d.valor)
                return (
                  <button type="button" key={d.valor} onClick={() => alternarDiaSemana(d.valor)}
                    style={{ padding: "6px 10px", borderRadius: 8, border: "none", cursor: "pointer",
                      fontFamily: "Inter", fontSize: 12,
                      background: marcado ? "#0ea5e9" : "#1a2744",
                      color: marcado ? "#fff" : "#94a3b8",
                      outline: marcado ? "2px solid #0ea5e9" : "1px solid #2d4166" }}>
                    {d.label}
                  </button>
                )
              })}
            </div>
            <div style={{ fontSize: 10, color: "#475569", marginTop: 4, marginBottom: 16 }}>
              Dias marcados = o checklist é obrigatório nesses dias (habilita o relatório de conformidade)
            </div>

            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Grupos — opcional</label>
            <div style={{ position: "relative", marginBottom: 8 }}>
              <input style={{ ...estiloInput, width: "100%" }} placeholder="Clique ou digite pra buscar um grupo..."
                value={buscaGrupo} onChange={e => setBuscaGrupo(e.target.value)}
                onFocus={() => setDropdownGrupoAberto(true)}
                onBlur={() => setTimeout(() => setDropdownGrupoAberto(false), 150)} />
              {dropdownGrupoAberto && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 10, marginTop: 4,
                  maxHeight: 180, overflow: "auto", background: corCard, border: `1px solid ${corBorda}`, borderRadius: 8 }}>
                  {gruposDisponiveis
                    .filter(g => g.tipo === 'setor')
                    .filter(g => !buscaGrupo.trim() || g.nome.toLowerCase().includes(buscaGrupo.trim().toLowerCase()))
                    .map(g => {
                      const marcado = gruposSelecionados.includes(g.id)
                      return (
                        <div key={g.id} onMouseDown={() => alternarGrupo(g.id)}
                          style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer",
                            background: marcado ? "rgba(14,165,233,0.1)" : "transparent", fontSize: 12 }}>
                          <span>{marcado ? "☑️" : "⬜"}</span>
                          <span>{g.nome}</span>
                        </div>
                      )
                    })}
                  {gruposDisponiveis.length === 0 && <div style={{ padding: 10, fontSize: 11, color: corMuted }}>Nenhum grupo cadastrado ainda.</div>}
                </div>
              )}
            </div>
            {gruposSelecionados.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
                {gruposSelecionados.map(id => {
                  const g = gruposDisponiveis.find(x => x.id === id)
                  return (
                    <span key={id} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11,
                      background: "rgba(14,165,233,0.15)", border: `1px solid ${corAccent}`, borderRadius: 20, padding: "3px 10px", color: "#38bdf8" }}>
                      {g?.nome || id}
                      <span style={{ cursor: "pointer" }} onClick={() => alternarGrupo(id)}>✕</span>
                    </span>
                  )
                })}
              </div>
            )}
            {gruposSelecionados.length === 0 && <div style={{ marginBottom: 16 }} />}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
              <label style={{ fontSize: 12, color: corMuted }}>Veiculos especificos — opcional, alem da categoria/grupo</label>
              <div style={{ display: "flex", gap: 10 }}>
                <span style={{ fontSize: 11, color: corAccent, cursor: "pointer" }}
                  onClick={() => {
                    const filtrados = ativosDisponiveis.filter(a => !buscaAtivo.trim() || `${a.nome} ${a.placa||""}`.toLowerCase().includes(buscaAtivo.trim().toLowerCase()))
                    setAtivosSelecionados(Array.from(new Set([...ativosSelecionados, ...filtrados.map(a => a.id)])))
                  }}>Selecionar todos</span>
                <span style={{ fontSize: 11, color: corMuted, cursor: "pointer" }} onClick={() => setAtivosSelecionados([])}>Limpar</span>
              </div>
            </div>
            <input style={{ ...estiloInput, width: "100%", marginBottom: 8 }} placeholder="🔍 Buscar veiculo por nome ou placa..."
              value={buscaAtivo} onChange={e => setBuscaAtivo(e.target.value)} />
            <div style={{ maxHeight: 160, overflow: "auto", border: `1px solid ${corBorda}`, borderRadius: 8, marginBottom: 8 }}>
              {ativosDisponiveis
                .filter(a => !buscaAtivo.trim() || `${a.nome} ${a.placa||""}`.toLowerCase().includes(buscaAtivo.trim().toLowerCase()))
                .slice(0, 50)
                .map(a => {
                  const marcado = ativosSelecionados.includes(a.id)
                  return (
                    <div key={a.id} onClick={() => alternarAtivo(a.id)}
                      style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer",
                        background: marcado ? "rgba(14,165,233,0.1)" : "transparent", borderBottom: `1px solid ${corFundo}`, fontSize: 12 }}>
                      <span>{marcado ? "☑️" : "⬜"}</span>
                      <span style={{ flex: 1 }}>{a.nome}</span>
                      {a.placa && <span style={{ color: corMuted, fontSize: 11 }}>{a.placa}</span>}
                    </div>
                  )
                })}
              {ativosDisponiveis.length === 0 && <div style={{ padding: 10, fontSize: 11, color: corMuted }}>Nenhum veiculo cadastrado ainda.</div>}
            </div>
            {ativosSelecionados.length > 0 && (
              <div style={{ fontSize: 11, color: "#38bdf8", marginBottom: 16 }}>{ativosSelecionados.length} veiculo(s) selecionado(s)</div>
            )}

            <div style={{ fontSize: 10, color: corMuted, marginBottom: 20 }}>
              Deixe grupo e veiculos vazios pra esse checklist valer pra qualquer veiculo.
              Marcando algum, so aparece pros veiculos que combinam com pelo menos uma das selecoes.
            </div>

            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button onClick={() => setModalModelo(false)}
                style={{ padding: "9px 16px", borderRadius: 8, border: `1px solid ${corBorda}`, background: "none", color: corMuted, cursor: "pointer", fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={salvarModelo} style={estiloBotao}>💾 Salvar</button>
            </div>
          </div>
        </div>
      )}

      {modalImportar && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 999,
          display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => !importando && setModalImportar(false)}>
          <div style={{ background: corFundo, border: `1px solid ${corBorda}`, borderRadius: 12, width: 520, maxHeight: "85vh",
            display: "flex", flexDirection: "column", overflow: "hidden" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ padding: "28px 28px 0 28px", flexShrink: 0 }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>📋 Importar perguntas</h3>
              <p style={{ fontSize: 12, color: corMuted, marginBottom: 8 }}>
                Marque as perguntas de outros modelos que quer copiar pra "{modeloSelecionado?.nome}".
              </p>
              <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                <span style={{ fontSize: 11, color: corAccent, cursor: "pointer" }}
                  onClick={() => setItensParaImportar(itensGlobais.filter(it => it.modelo_id !== modeloSelecionado?.id).map(it => it.id))}>
                  Selecionar todos
                </span>
                <span style={{ fontSize: 11, color: corMuted, cursor: "pointer" }}
                  onClick={() => setItensParaImportar([])}>
                  Desmarcar todos
                </span>
              </div>
            </div>
            <div style={{ padding: "0 28px", overflow: "auto", flex: 1 }}>
              {Object.entries(
                itensGlobais
                  .filter(it => it.modelo_id !== modeloSelecionado?.id)
                  .reduce((acc: Record<string, any[]>, it: any) => {
                    (acc[it.modelo_nome] = acc[it.modelo_nome] || []).push(it)
                    return acc
                  }, {})
              ).map(([nomeModelo, itensDoModelo]: [string, any]) => (
                <div key={nomeModelo} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: corMuted, textTransform: "uppercase", marginBottom: 6 }}>{nomeModelo}</div>
                  {itensDoModelo.map((it: any) => {
                    const marcado = itensParaImportar.includes(it.id)
                    return (
                      <div key={it.id} onClick={() => alternarItemImportar(it.id)}
                        style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", cursor: "pointer",
                          background: marcado ? "rgba(14,165,233,0.1)" : "transparent", borderRadius: 6, fontSize: 13 }}>
                        <span>{marcado ? "☑️" : "⬜"}</span>
                        <span style={{ flex: 1 }}>{it.pergunta}</span>
                        {it.pode_gerar_os && <span style={{ fontSize: 12 }} title="Pode gerar OS">🔧</span>}
                      </div>
                    )
                  })}
                </div>
              ))}
              {itensGlobais.filter(it => it.modelo_id !== modeloSelecionado?.id).length === 0 && (
                <div style={{ fontSize: 12, color: corMuted }}>Nenhuma pergunta em outros modelos ainda.</div>
              )}
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", padding: 20, borderTop: `1px solid ${corBorda}`, flexShrink: 0 }}>
              <button onClick={() => setModalImportar(false)} disabled={importando}
                style={{ padding: "9px 16px", borderRadius: 8, border: `1px solid ${corBorda}`, background: "none", color: corMuted, cursor: "pointer", fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={importarSelecionadas} disabled={importando || itensParaImportar.length === 0} style={estiloBotao}>
                {importando ? "Importando..." : `Importar (${itensParaImportar.length})`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
